<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { provideMessageContext } from './provider';
import BaseBubble from './bubbles/Base.vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

const props = defineProps({
  text: { type: String, required: true },
  role: { type: String, default: 'assistant' },
  senderName: { type: String, default: '' },
  createdAt: { type: String, default: null },
});

const { t, locale } = useI18n();
const timestamp = computed(() =>
  props.createdAt
    ? new Intl.DateTimeFormat(locale.value.replace('_', '-'), {
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(props.createdAt))
    : ''
);

provideMessageContext({
  variant: computed(() => (props.role === 'user' ? 'agent' : 'user')),
  orientation: computed(() => (props.role === 'user' ? 'right' : 'left')),
  inReplyTo: ref(null),
  shouldGroupWithNext: ref(false),
  id: ref(0),
  sender: ref(null),
  senderType: ref(null),
});
</script>

<template>
  <div
    class="flex items-end gap-2 message-bubble-container"
    :class="role === 'user' ? 'flex-row-reverse ms-8' : 'me-8'"
  >
    <Avatar
      :name="senderName || t('ACTIVATION_GUIDE.NAME')"
      :icon-name="role === 'assistant' ? 'i-lucide-bot' : null"
      :size="24"
      class="shrink-0"
    />
    <BaseBubble hide-meta>
      <p class="whitespace-pre-wrap break-words m-0 p-3">{{ text }}</p>
      <time
        v-if="createdAt"
        :datetime="createdAt"
        class="block px-3 pb-2 text-end text-xxs text-n-slate-11"
      >
        {{ timestamp }}
      </time>
    </BaseBubble>
  </div>
</template>
